/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Evaluating_OneaiInputs */



/**
* | output |
* | --- |
* | "Evaluating oneAI for my company" |
*
* @param {Onboarding_Usage_Evaluating_OneaiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_evaluating_oneai = /** @type {((inputs?: Onboarding_Usage_Evaluating_OneaiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Evaluating_OneaiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI für mein Unternehmen evaluieren")
	return /** @type {LocalizedString} */ ("Evaluating oneAI for my company")
});